<template>
  <div class="mx-0">
    <v-img
      height="100vh"
      :src="
        $webp ? 'imagenes/credito_mipyme.webp' : 'imagenes/credito_mipyme.jpg'
      "
      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    >
      <v-layout column align-center justify-center fill-height mx-12>
        <v-flex xs1 sm1 md1 lg1>
          <h1 class="font-weight-bold white--text text-center">
            Crédito MIPYME
          </h1>
          <h3 v-html="colorBannerTextHome" class="white--text text-center"></h3>
        </v-flex>
      </v-layout>
    </v-img>
    <vc-request-modal />
    <vc-requirements-mipyme />
    <vc-politic-banner :image="`imagenes/logo.svg`"></vc-politic-banner>
    <vc-footer></vc-footer>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialog"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-container class="pb-0">
            <p class="primary--text">Pre-solicitud de Crédito</p>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Nombre completo *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Correo electronico *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Direccion del negocio * "></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Cuidad o localidad *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Código postal *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  v-mask="'(###)-###-####'"
                  label="Telefono con lada *"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-autocomplete
                  :items="[
                    'Abarrotes',
                    'Carniceria',
                    'Constructora',
                    'Consultorios médicos',
                    'Dulcerías',
                    'Electronica y Computo',
                    'Farmacias',
                    'Fotografia (estudio)',
                    'Fruterías',
                    'Hoteles y Moteles',
                    'Imprentas y editoriales',
                    'Joyeria y relojeria',
                    'Laboratorios clínicos',
                    'Librerias',
                    'Madererías',
                    'Marisquerías',
                    'Mueblería',
                    'Panaderias',
                    'Purificadora de agua',
                    'Refaccionaria',
                    'Restaurante',
                    'Rosticeria',
                    'Talleres',
                    'Telefonia',
                    'Tortillerias',
                    'Videoclub',
                    'Vinos y licores',
                    'Otro comercio o negocio',
                  ]"
                  label="Giro de su negocio * "
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indica el campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary_dark" text @click="dialog = false"
            >Enviar solicitud</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    dialog: false,
    colorBannerTextHome: "Aplica solo para reestructura de creditos",
    colorBannerText: "Aplica solo para reestructuras de creditos",
  }),
};
</script>
<style scoped>
.bg-white {
  background-color: #ffffff !important;
}
.container {
  max-width: 2785px !important;
}
.bg-primary_dark {
  background: #8a172b !important;
}
.animated {
  -webkit-animation: pulse 0.5s infinite alternate;
  animation: pulse 0.5s infinite alternate;
}
@-webkit-keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
  }
}
@keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
</style>
